// Determines whether a student's intake falls after the agent details cutoff date.
// Returns false (safe default) for malformed/missing values.
//
// SYNC WARNING: This function is duplicated in the backend at:
//   cas/lambdas/ts/student-manager/src/helpers/isIntakeAfterAgentDetailsCutoff.ts
// Both implementations must stay identical. Update both when changing logic.

// Intake cutoff constants (Stack 28 Phase 28.6 — inlined from data/agentDetails).
// Both this file and platform/frontend/shared-components/lib/utilities/intakeCutoff
// duplicate the same constants; update in lock-step. Students in intakes on or
// before the cutoff are excluded from the agent details section.
const AGENT_DETAILS_INTAKE_CUTOFF = '2025-12';
const ACADEMIC_YEAR_UNIS: readonly string[] = ['LE'];

const YYYY_MM_PATTERN = /^\d{4}-\d{2}$/;
const ACADEMIC_YEAR_FIRST_MONTH = 1;
const ACADEMIC_YEAR_LAST_MONTH = 8;

export function isIntakeAfterAgentDetailsCutoff(intakeValue: string | undefined, uni: string): boolean {
  if (!intakeValue || !YYYY_MM_PATTERN.test(intakeValue)) {
    return false;
  }

  const monthNumber = parseInt(intakeValue.slice(5, 7), 10);
  if (Number.isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12) {
    return false;
  }

  let adjustedValue = intakeValue;

  if (ACADEMIC_YEAR_UNIS.includes(uni)) {
    if (monthNumber >= ACADEMIC_YEAR_FIRST_MONTH && monthNumber <= ACADEMIC_YEAR_LAST_MONTH) {
      const year = parseInt(intakeValue.slice(0, 4), 10);
      const month = intakeValue.slice(5, 7);
      adjustedValue = `${year + 1}-${month}`;
    }
  }

  return adjustedValue > AGENT_DETAILS_INTAKE_CUTOFF;
}
